import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PlayStationPlatformSelectBox, XboxPlatformSelectBox } from '../../auth'
import Header from '../../components/Layout/Header'

const PlatformLoginPage: React.FC = () => {
  const { t } = useTranslation('vpc', { keyPrefix: 'vpc' })

  return (
    <Box sx={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
      <Box sx={{ mb: '2rem' }}>
        <Header
          data-testid="platform-select-header"
          title={t('login.title')}
          subtitle={t('login.subtitle')}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'start',
          flexWrap: 'wrap',
          gap: '2rem',
        }}
      >
        <XboxPlatformSelectBox />
        <PlayStationPlatformSelectBox />
      </Box>
    </Box>
  )
}

export default PlatformLoginPage
